import { GET } from 'utils/requests.utils'

const BASE_URL = (username) => `/shop/${username}/seller`

export const fetchItem = (data) => GET(BASE_URL(data.username))

export default fetchItem
